<template>
    <div
        class="tw-my-8"
    >
        <Heading :title="'Wann möchtest Du ' + countryName + ' erleben?'" :size="3" />

        <!-- Year Selector -->
        <label class="tw-block">
            <span class="tw-font-medium">Jahr*</span>
            <select
                v-model="selectedYear"
                id="YearSelector"
                :class="selectClass('year')"
                @focus="activeField = 'year'"
                @blur="activeField = ''"
                @mouseover="hoverField = 'year'"
                @mouseleave="hoverField = ''"
            >
                <option value="" disabled>Wähle ein Jahr aus</option>
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
            </select>
        </label>

        <!-- Month Selector -->
        <label class="tw-block">
            <span class="tw-font-medium">Monat*</span>
            <select
                v-model="selectedMonth"
                id="MonthSelector"
                :class="selectClass('month')"
                @focus="activeField = 'month'"
                @blur="activeField = ''"
                @mouseover="hoverField = 'month'"
                @mouseleave="hoverField = ''"
            >
                <option value="" disabled>Wähle einen Monat aus</option>
                <option v-for="month in activeMonths" :key="month.value" :value="month.value">{{ month.name }}</option>
            </select>
        </label>
    </div>
</template>

<script>

export default {
    name: "TimeSelector",
    props: {
        countryName: {
            type: String,
            required: true
        }
    },
    data: () => ({
        years: [new Date().getFullYear(), new Date().getFullYear()+1, new Date().getFullYear()+2],
        months: [{value: 1, name:"Januar"}, {value: 2, name:"Februar"}, {value: 3, name:"März"}, {value: 4, name:"April"}, {value: 5, name:"Mai"}, {value: 6, name:"Juni"}, {value: 7, name:"Juli"}, {value: 8, name:"August"}, {value: 9, name:"September"}, {value: 10, name:"Oktober"}, {value: 11, name:"November"}, {value: 12, name:"Dezember"}],
        activeMonths: [],
        selectedYear: '',
        selectedMonth: '',
        activeField: '',
        hoverField: '',
    }),
    created() {
        this.selectedYear = this.$store.getters['tour/travelData'].year;
        if(this.selectedYear === new Date().getFullYear()) {
            this.activeMonths = this.months.filter(month => month.value >= new Date().getMonth() + 1);
        } else {
            this.activeMonths = this.months;
        }
        // check if the month from store is within the active months
        if(this.selectedMonthValid) {
            this.selectedMonth = this.$store.getters['tour/travelData'].month;
        } else {
            this.$store.commit('tour/setMonth', '');
            this.selectedMonth = '';
        }
    },
    computed: {
        selectedMonthValid: function () {
            return this.activeMonths.find(month => month.value === this.$store.getters['tour/travelData'].month)
        },
    },
    watch: {
        selectedYear: function (val) {
            this.$store.commit('tour/setYear', parseInt(val));
            if(val === new Date().getFullYear()) {
                this.activeMonths = this.months.filter(month => month.value >= new Date().getMonth() + 1);
                if (!this.selectedMonthValid) {
                    this.selectedMonth = '';
                }
            } else {
                this.activeMonths = this.months;
            }
        },
        selectedMonth: function (val) {
            this.$store.commit('tour/setMonth', parseInt(val));
            this.$store.commit('tour/setFullMonthName', this.months[val-1].name);
        }
    },
    methods: {
        selectClass(type) {
            const isActive = this.activeField === type;
            const isHover = this.hoverField === type;
            let base = 'tw-w-full tw-bg-white tw-rounded-sm tw-p-2 tw-mt-2 tw-mb-4 tw-appearance-none';
            if (isActive) {
                base += ' tw-border-2 tw-border-black';
            } else if (isHover) {
                base += ' tw-border tw-border-black';
            } else {
                base += ' tw-border tw-border-gray-300';
            }
            return base;
        }
    }
}
</script>

<style scoped>
select:focus,
select:focus-visible {
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    outline: none;
}

/* Remove default select arrow in Safari */
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.5rem center;
    background-size: 1em;
    padding-right: 2.5rem;
}
</style>
